// test1757
(1757 && 0);
